import * as md5 from 'md5'

export function Avatar({
    name,
    email,
    size
}){
    return <div style={{ width: `${size}px`, height: `${size}px`, overflow: 'hidden', borderRadius: '50%', background: 'var(--accent-color)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {/* <img src={`https://www.gravatar.com/avatar/${md5(email)}?d=identicon`} alt={name} style={{ height: '100%', width: '100%' }}/> */}
        <span>{name.split(' ').map(s => s[0]).join('')}</span>
    </div>
}
